import React, { useEffect, useState } from "react";
import { ApiResponse } from "../../../api/master/axiosIndex";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { RootState } from "../../../store/store";
import { useSelector } from "react-redux";
import { Card } from "antd";
import ActivityStreamLine from "../activityStreamLine/ActivityStreamLine";
import { tasksApis } from "../../../api/NewTasks";

const TaskActivityStreamLine = ({ activeTab }: { activeTab: string }) => {
  const [activityStreamLineData, setActivityStreamLineData] = useState<any>();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: locationProjectId, extra: extraData } = location.state || {};
  const { data: TaskListInDetailModal } = useSelector(
    (state: RootState) => state.TaskListInDetailModal
  );

  // Get projectId from Redux state or fallback to location state
  const projectId = TaskListInDetailModal?.projectResponse?.id ||
                    TaskListInDetailModal?.selectedTaskDetails?.projectId ||
                    locationProjectId;

  useEffect(() => {
    if (activeTab === "activitystream" && projectId && TaskListInDetailModal?.id) {
      getStatusTimeLineData();
    }
  }, [activeTab, projectId, TaskListInDetailModal?.id]);

  const getStatusTimeLineData = async () => {
    try {
      const apiResponse: ApiResponse =
        await tasksApis.fetchTaskActivityStreamlines(
          projectId,
          TaskListInDetailModal?.id
        );
      const { data, status } = apiResponse;
      if (status) {
        console.log("data", data);
        setActivityStreamLineData(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {activityStreamLineData && (
        <Card className="card-bordered mt-3" style={{ padding: "20px 50px" }}>
          <ActivityStreamLine groupedActivities={activityStreamLineData} />
        </Card>
      )}
    </>
  );
};

export default TaskActivityStreamLine;
